import React from "react";
import Grid from "../Grid";
import ChevronDownIcon from "../Icons/ChevronDown";
import styled, { css } from "styled-components";
import CloseIcon from "../Icons/Close";
import CloseV2 from "../Icons/CloseV2";

const DropdownStyles = styled.div`
  ${({ ...props }) => css`
    position: relative;

    label {
      position: absolute;
      top: 2px;
      left: 2px;
      height: calc(100% - 4px);
      width: calc(100% - 4px);
      background-color: ${props.$isActive ? props.theme.colors.darkGrey : "#fff"};
      color: ${props.$isActive ? "#fff" : props.theme.colors.text};
      border-radius: 4px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      font-size: 1rem;
      line-height: 1.2;

      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        /* Leave space for the SVG */
        width: calc(100% - 1.875rem);
      }

      &:has(+ select:disabled) {
        background-color: #D8D8D6;
      }

      svg {
        width: 1.5rem;
        height: 1.5rem;
        color: #707070
      }
    }

    select {
      position: relative;
      z-index: ${props.$isActive ? -1 : 1};
      opacity: 0;
      height: 100%;
      width: 100%;
      cursor: pointer;
      font-size: 1rem;
      line-height: 1.2;

      &:disabled {
        cursor: not-allowed;
      }
    }

    select, label {
      padding: 20px;
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      select, label {
        padding: 26px;
      }
    }
  `}
`;

export const FilterDropdown = ({
  label,
  name,
  filters,
  selectedValue,
  onChange,
  defaultValue,
  show
}) => {
  if (!show || !Array.isArray(filters)) return null;

  const isActive = selectedValue !== defaultValue;

  const sortFilters = (a, b) => {
    return a.termOrder - b.termOrder;
  };

  const currentFilter = filters.find((filter) => filter.name === selectedValue)
  const currentCount = currentFilter ? currentFilter.count : 0

  const handleOnClick = () => {
    if (isActive) {
      onChange({ target: { name, value: defaultValue } });
    }
  }

  return (
    <Grid item xs={6} md={4} lg={3} className="filter-dropdown">
      <DropdownStyles $isActive={isActive}>
        <label onClick={handleOnClick} htmlFor={name}>
          <span>{isActive ? `${selectedValue} (${currentCount})` : label}</span>
          {isActive ? <CloseV2 /> : <ChevronDownIcon />}
        </label>
        <select
          name={name}
          id={name}
          onChange={onChange}
          value={selectedValue}
          disabled={filters.length === 0}
        >
          <option value={defaultValue} disabled>{label}</option>
          {filters.sort(sortFilters).map((filter) => (
            <option
              key={filter.name}
              value={filter.name}
              disabled={filter.count === 0}
            >
              {filter.name} ({filter.count})
            </option>
          ))}
        </select>
      </DropdownStyles>
    </Grid>
  );
};
